'use strict';

/**
 * Dependencies
 */

var uniqueRandomArray = require('unique-random-array');
var catFacts = require('./cat-facts.json');


/**
 * Interesting cat facts
 */

exports.random = uniqueRandomArray(catFacts);
exports.all = catFacts;



//////////////////
// WEBPACK FOOTER
// ./node_modules/cat-facts/index.js
// module id = ./node_modules/cat-facts/index.js
// module chunks = 0